<div class="error">
    @if (message()) {
    <mat-error>
        {{message()}}
    </mat-error>
    }
</div>
